jQuery(document).ready((function(e) {

    // Effect Nav
    const scrollNav = () => {
        document.addEventListener('scroll', () => {

            // Header
            const header = document.querySelector('#header');
        
            if (window.scrollY > 100) {
                header.classList.add('scroll');
            } else {
                header.classList.remove('scroll');
            }
        
            });
    };

    let swiperHero  = new Swiper(".mySwiperHero", {
        slidesPerView: 1,
        spaceBetween: 0,
        centeredSlides: true,
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
            renderBullet: function (index, className) {
              return '<span class="' + className + '">' + (index + 1) + "</span>";
            },
          },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
            clickable: true,
        },
    });

    let swiperEvents  = new Swiper(".mySwiperEvents", {
        slidesPerView: 1.2,
        spaceBetween: 20,
        centeredSlides: true,
        breakpoints: {
            1200: {
                slidesPerView: 3,
                centeredSlides: false,
                spaceBetween: 30,
            },
        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
            clickable: true,
        },
    });

    jQuery('.navbar-toggler').on('click', function() {
        jQuery('.navbar').toggleClass('opened');
    });

    new ModalVideo(".js-modal-btn");
    scrollNav();
    AOS.init({
        duration: 1000
    });
}));